module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./~/sass-loader!./src/app/theme/components/baMenu/components/baMenuItem/baMenuItem.scss
// module id = 497
// module chunks = 16